/** @flow */
import { createSelector } from 'reselect';


const checkState = state => state;

const selectApp = createSelector(
  checkState,
  state => state.get('app'),
);

export default createSelector(
  selectApp,
  app => app.get('popup'),
);
